var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.href)?_c('router-link',{attrs:{"to":_vm.href}},[_vm._v(" "+_vm._s(_vm.text)+" ")]):[_vm._v(_vm._s(_vm.text))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }